// extracted by mini-css-extract-plugin
module.exports = {"container":"_1777641","header":"_260ef3b","title":"_1183528","info":"_8f38fc7","row":"_d2f2484","buttonContainer":"_47727ad","buyIn":"_43a2512"};